import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import produce from 'immer';
// import axios from 'axios';
import {
  getAvailableProducts,
  // getSearchResult,
  getStaticContent,
} from './universalDataFetchers';
import logger from '../common/logger';
import { getChildProperty } from '../common/object';
// import { getEnvironmentConstant } from '../common/utilities';
import {
  // ROUTER_BASENAME,
  EDC_SLUGS_INDEX,
  // COURSE_API_HOST,
  EDC_SLUGS_PERSONALIZED,
} from '../common/constants';

export const fetchIndexData = createAsyncThunk(
  'indexData',
  ({
    env, isPreview, appVersion, personalised = false,
  }, { rejectWithValue }) => Promise.allSettled([
    getStaticContent({
      env, isPreview, slugs: personalised ? EDC_SLUGS_PERSONALIZED : EDC_SLUGS_INDEX,
    }),
    getAvailableProducts({ env, appVersion }),
  ]).then((res) => {
    const errorRes = res.find((data) => data.status !== 'fulfilled');
    if (errorRes) {
      return rejectWithValue(errorRes?.reason);
    }
    return res.map((data) => data.value);
  }),
);

// export const fetchIndexDataByProdGuid = createAsyncThunk(
//   'indexDataByProdGuid',
//   ({
//     guid, filterValue = null, env, appVersion,
//   }) => {
//     const contentfulDataFetchURL = `${getEnvironmentConstant({ key: COURSE_API_HOST, env })}${getEnvironmentConstant({ key: ROUTER_BASENAME, env })}/api/index/v1/${guid}`;
//     return Promise.all(
//       [
//         axios.get(contentfulDataFetchURL),
//         // getSearchResult({ catalogResult: { page: 0, perPage: 1, filters: { product: [filterValue] } }, env, appVersion })],
//         getSearchResult({
//           catalogResult: { page: 0, perPage: 1 }, presetFilterString: `/product/${filterValue}`, env, appVersion,
//         })],
//     );
//   },
// );

export const indexSlice = createSlice({
  name: 'indexData',
  initialState: {
    data: {},
    editorial: {},
    initiatedSearch: false,
  },
  reducers: {
    setInitiatedSearch: (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.initiatedSearch = action?.payload;
      });
      return newState;
    },
    setSelectedProduct: (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.data.selectedProduct = action?.payload;
      });
      return newState;
    },
    setIndustryToggleState: (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.data.industryToggleState = action?.payload;
      });
      return newState;
    },
    // clearIndexDataByProdGuid: (state) => {
    //   const newState = produce(state, (draftState) => {
    //     delete draftState.data.guidData;
    //     delete draftState.data.filters;
    //     delete draftState.data.filterGroups;
    //   });
    //   return newState;
    // },
  },
  extraReducers: (builder) => {
    // builder.addCase(fetchIndexDataByProdGuid.pending, (state) => ({
    //   ...state,
    //   isLoaderVisible: true,
    // }));
    // builder.addCase(fetchIndexDataByProdGuid.fulfilled, (state, action) => {
    //   const newState = produce(state, (draftState) => {
    //     draftState.isLoaderVisible = false;
    //     draftState.data.guidData = { ...action?.payload[0]?.data };
    //     draftState.data.filters = action?.payload[1][0].filters;
    //     draftState.data.filterGroups = action?.payload[1][0].filterGroups;
    //   });
    //   return newState;
    // });
    // builder.addCase(fetchIndexDataByProdGuid.rejected, (state, action) => {
    //   logger.error('Error in fetchIndexDataByProdGuid: ', action.error);
    //   return {
    //     ...state,
    //     isLoaderVisible: false,
    //   };
    // });
    builder.addCase(fetchIndexData.pending, (state) => ({
      ...state,
      isLoaderVisible: true,
    }));
    builder.addCase(fetchIndexData.fulfilled, (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.isLoaderVisible = false;
        draftState.editorial = getChildProperty(action, 'payload[0]');
        draftState.data = getChildProperty(action, 'payload[1]');
      });
      return newState;
    });
    builder.addCase(fetchIndexData.rejected, (state, action) => {
      logger.error('Error in fetchIndexData: ', action.error);
      return {
        ...state,
        isLoaderVisible: false,
      };
    });
  },
});

export const {
  // clearIndexDataByProdGuid,
  setSelectedProduct, setIndustryToggleState, setInitiatedSearch,
} = indexSlice.actions;

// Export getters for store data
export const getInitiatedSearch = (state) => state.indexData.initiatedSearch;
export const getEditorialData = (state) => state.indexData.editorial;
// export const getPersonalizedEditorialData = (state) => state.indexData.personalizedEditorial;
export const getProductList = (state) => getChildProperty(state, 'indexData.data.productList');
export const getIndustrySubSegments = (state) => getChildProperty(state, 'indexData.data.industrySubSegments');
// export const getData = (state) => state.indexData.data;
// export const getDataForProdGuid = (state) => getChildProperty(state, 'indexData.data.guidData');
export const isLoaderVisible = (state) => state.indexData.isLoaderVisible;
export const getSelectedProduct = (state) => getChildProperty(state, 'indexData.data.selectedProduct');
export const getIndustryToggleState = (state) => getChildProperty(state, 'indexData.data.industryToggleState');

// export const getIndustryFilter = (state) => {
//   const filterGroups = getChildProperty(state, 'indexData.data.filterGroups');
//   let industryFilter = {};
//   if (filterGroups?.length) {
//     // eslint-disable-next-line consistent-return
//     filterGroups.forEach((fg) => {
//       const filter = fg?.filters?.find((f) => f.id === 'industry');
//       if (filter) {
//         industryFilter = { ...filter, selections: filter?.selections?.filter((s) => s.count > 0) || [] };
//       }
//     });
//   }
//   return industryFilter;
// };
// export const getCapabilitiesFilter = (state) => {
//   const filterGroups = getChildProperty(state, 'indexData.data.filterGroups');
//   let capabilityFilter = {};
//   if (filterGroups?.length) {
//     // eslint-disable-next-line consistent-return
//     filterGroups.forEach((fg) => {
//       const filter = fg?.filters?.find((f) => f.id === 'capabilities');
//       if (filter) {
//         capabilityFilter = { ...filter, selections: filter?.selections?.filter((s) => s.count > 0) || [] };
//       }
//     });
//   }
//   return capabilityFilter;
// };

export const hasEducators = (state, destinationUrl, sentfilters) => {
  if (destinationUrl) {
    const filters = sentfilters || getChildProperty(state, 'indexData.data.filters');
    const educatorFilter = filters?.filter((f) => f.id === 'educators');
    if (educatorFilter?.length) {
      return educatorFilter[0]?.selections.filter((s) => destinationUrl.includes(s.value) && s.count > 0).length > 0;
    }
  }
  return false;
};

export const hasCertifications = (state, sentfilters) => {
  const filters = sentfilters || getChildProperty(state, 'indexData.data.filters');
  const certificationFilter = filters?.filter((f) => f.id === 'certification');
  if (certificationFilter?.length) {
    return certificationFilter[0]?.selections.filter((s) => s.count > 0).length > 0;
  }

  return false;
};

// Export reducer by default for import by store config
export default indexSlice.reducer;
